import Component from 'component';
import Cookies from 'js-cookie';

class PhoneSwap extends Component {
  constructor(el) {
    super(el);

    this.setPPCFranchiseId();
    this.setLocalizedFranchiseId();

    // If the PPC query params exists, then skip this and go right to the phone swap
    if (!this.idInQueryString) {
      if (typeof this.localizedFID !== 'undefined') {
        this.ppcFID = this.localizedFID;
        this.setPPCFranchiseIdCookie(this.ppcFID);
      }
    }

    this.parsePhoneNumbers();
    this.swap();
  }

  setupDefaults() {
    this.$phoneElements = this.$el;
    this.phoneNumbers = [];
    this.ppcFID = null; //Franchise ID passed in from PPC campaign
    this.localizedFID = null; //Franchise ID of the localized franchise
    this.idCookieName = 'yotrack-fid';
    this.metadataCookieName = 'YoTrackMetaDataWidget';
    this.idInQueryString = false;
  }

  parsePhoneNumbers() {
    for(const item of this.$phoneElements) {
      let origNum = item.getAttribute('href');

      if (origNum.includes('tel:')) {
        origNum = origNum.replace('tel:', '');

        if (origNum !== '') {
          this.addPhoneNumberToList(origNum);

          const strippedNum = origNum.replace(/\D/g, '');
          this.addPhoneNumberToList(strippedNum);
        }
      }
    }
  }

  addPhoneNumberToList(num) {
    if (!this.phoneNumbers.includes(num)) {
      this.phoneNumbers.push(num);
    }
  }

  // Get FID of the current localized page
  setLocalizedFranchiseId() {
    this.localizedFID = $('[data-fid]').data('fid');
  }

  // Get FID associated with a particular PPC campaign
  setPPCFranchiseId() {
    const url = new URL(window.location);
    let fid = url.searchParams.get('fid');

    if (!this.isValidFranchiseId(fid)) {
      fid = this.getFranchiseIdFromCookie(this.idCookieName);
    } else {
      this.idInQueryString = true;
      this.setPPCFranchiseIdCookie(fid);
    }

    this.ppcFID = fid;
  }

  setPPCFranchiseIdCookie(fid) {
    Cookies.set(this.idCookieName, fid, { expires: 14 });
  }

  getFranchiseIdFromCookie(cookieName) {
    const fid = Cookies.get(cookieName);

    if (this.isValidFranchiseId(fid)) {
      return fid;
    }

    return null;
  }

  isValidFranchiseId(fid) {
    if (typeof fid === 'undefined' || fid === null || fid === 'undefined' || fid === '') {
      return false;
    }

    return true;
  }


  swap() {
    if (!this.isValidFranchiseId(this.ppcFID) || this.phoneNumbers.length === 0) {
      return;
    }
    //get info attached to body tag.  jquery will automatically parse JSON
    const yoTrackInfo = $('[data-hfc-yotrack-info]').data('hfc-yotrack-info');
    if (typeof (yoTrackInfo) === 'object') {

      const numbers = this.phoneNumbers;
      //yotrack id is embedded in html attribute
      const yotrackId = yoTrackInfo.id;
      const cookieName = this.metadataCookieName;

      window.YoTrack(yotrackId,
        (err, api) => {
          if (err) {

            window.YoTrack(yotrackId,
              (err, api) => {
                api.swapPhones(numbers,
                  (err, line) => {
                    console.log('Error: ', err)
                    console.log('Phone Number: ', line)
                  })
              })
          } else {
            api.swapPhones(numbers,
              (err, line) => {
                console.log('Error: ', err)
                console.log('Phone Number: ', line)
              })
          }

          api.getMetadata((err, metadata) => {
            Cookies.set(cookieName, metadata, { expires: 1 });
            console.log('Meta-data: ', metadata)
          });

          api.isSEMSession((err, isSEMSession) => {
            console.log('Is SEM Session: ', isSEMSession /*true or false*/);
          });
        });
    }
  }
}


export default PhoneSwap;



// WEBPACK FOOTER //
// ./src/pg/js/components/PhoneSwap.js